import { ConvertType, useFormatNumber } from '../../../hooks/useFormatNumber';
import { PropertyUIConfig } from '../types';

export function GetUnit(ui?: PropertyUIConfig) {
  const { unitChar } = useFormatNumber();

  if (!ui || ui.hideUnit) return undefined;

  return ui?.customUnit || unitChar(ui.useUserPreferenceConvertType || ConvertType.NONE);
}
